module.exports = __webpack_public_path__ + "static/media/facebook.108618bc.svg";